module.exports = {
    totalWard: 5,
};
